import { useSyncExternalStore } from "react";
import { api } from "@/lib/api";

// J1 — 異常與燈號規則 (from /api/settings/rules). Defaults mirror backend RULE_DEFAULTS until loaded.
export const RULE_FALLBACK = {
  values: { ctr_red_below: 3, ctr_yellow_below: 5, roas_green_min: 35, roas_yellow_min: 20, cpa_green_max: 40, cpa_yellow_max: 80 },
  enabled: {},
};
let state = RULE_FALLBACK;
const listeners = new Set();

export const getRules = () => state;
export function setRules(data) {
  state = { values: { ...RULE_FALLBACK.values, ...(data?.values || {}) }, enabled: data?.enabled || {} };
  listeners.forEach((l) => l());
}
export const loadRules = () => api.get("/settings/rules").then((r) => { setRules(r.data); return r.data; }).catch(() => null);
export const useRules = () => useSyncExternalStore((cb) => { listeners.add(cb); return () => listeners.delete(cb); }, getRules);
export const ruleOn = (id) => getRules().enabled[id] !== false;
